var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewHidden(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.43 15",
    style: {
      enableBackground: "new 0 0 21.43 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#969492;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.72,10.88c-1.59,0-2.88-1.29-2.88-2.88c0-0.3,0.06-0.59,0.15-0.87L6.62,6.09C6.35,6.67,6.19,7.32,6.19,8 c0,2.5,2.03,4.53,4.53,4.53c0.01,0,0.02,0,0.03,0c1.1,0,2.1-0.42,2.88-1.08l-1.35-1.03C11.83,10.71,11.29,10.88,10.72,10.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.72,5.12c0.01,0,0.02,0,0.03,0c1.45,0.01,2.63,1.1,2.81,2.51l1.6,1.22c0.05-0.28,0.08-0.56,0.08-0.85 c0-2.5-2.03-4.53-4.53-4.53c-0.71,0-1.37,0.18-1.97,0.47l1.59,1.22C10.46,5.14,10.59,5.12,10.72,5.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.34,8.37c0.12-0.23,0.12-0.51,0-0.74c-2.77-5.67-9.47-8.11-15.21-5.69l2.61,2c0.6-0.29,1.26-0.47,1.97-0.47 c2.5,0,4.53,2.03,4.53,4.53c0,0.29-0.03,0.57-0.08,0.85l3.73,2.86C19.89,10.75,20.73,9.63,21.34,8.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.74,12.53c-0.01,0-0.02,0-0.03,0c-2.5,0-4.53-2.03-4.53-4.53c0-0.68,0.16-1.33,0.43-1.91l-3.27-2.5 C1.99,4.67,0.87,6.05,0.09,7.63c-0.12,0.23-0.12,0.51,0,0.74c2.87,5.87,9.95,8.3,15.82,5.43c0.16-0.08,0.3-0.16,0.46-0.25 l-2.74-2.1C12.84,12.11,11.85,12.53,10.74,12.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.75,5.12c-0.01,0-0.02,0-0.03,0c-0.13,0-0.25,0.02-0.38,0.04l3.23,2.47C13.38,6.22,12.2,5.13,10.75,5.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.83,8c0,1.59,1.29,2.88,2.88,2.88c0.58,0,1.11-0.17,1.56-0.46l-4.3-3.28C7.89,7.41,7.83,7.7,7.83,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.04,13.21l-1.52-1.16l-3.51-2.68l-1.45-1.11L9.71,5.31L8.26,4.2L5.6,2.17L3.04,0.21 C2.6-0.13,1.97-0.05,1.64,0.39C1.3,0.83,1.39,1.46,1.82,1.79l1.93,1.48l3.11,2.38l1.32,1.01l4.5,3.44L14,11.11l2.84,2.17l1.98,1.51 c0.18,0.14,0.4,0.21,0.61,0.21c0.3,0,0.6-0.14,0.8-0.39C20.56,14.17,20.48,13.54,20.04,13.21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewHidden);
export default __webpack_public_path__ + "static/media/preview-hidden.53d4436e5e6dd1e376a65be84e7ee96f.svg";
export { ForwardRef as ReactComponent };